import { Navigate, Outlet, RouteObject } from "react-router-dom";
import PageNotFound from "../pages/404";
import SingleVideo from "../pages/SingleVideo";
import Videos from "../pages/Videos";
import Home from "../pages/Home";
import { AppRoutes } from "../shared/constant";

export const PublicRoutesObject: RouteObject[] = [
  {
    path: "/",
    element: <Outlet />,
    children: [
      { index: true, element: <Home /> },
      {
        path: AppRoutes.videos.route,
        element: <Outlet />,
        children: [
          { index: true, element: <Videos /> },
          { path: ":videoId", element: <SingleVideo /> },
        ],
      },
      // legacy pages retired: send old links to the video library
      { path: "our-team", element: <Navigate to="/videos" replace /> },
      { path: "faq", element: <Navigate to="/videos" replace /> },
      { path: "careers", element: <Navigate to="/videos" replace /> },
      { path: "contact-us", element: <Navigate to="/videos" replace /> },
      { path: "/404", element: <PageNotFound /> },
      { path: "*", element: <PageNotFound /> },
    ],
  },
];

export const ProtectedRoutesObject: RouteObject[] = [];
